import styled from 'styled-components';

export const PieChartWidgetStyled = styled.div`
  display: grid;
  width: 100%;
  height: 100%;
`;
